import { ICampaignServer } from "model/campaigns";
import { LoadingState } from "model/Types/loading";
import React from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "redux/store";
import { fetchCampaignsWithApps } from "./campaignsActions";
import { getCampaignsList, getCampaignsLoadingState } from "./selectors";
import { IArchivedStatus } from "./types";

type IUseCampaignsResult = [ICampaignServer[], boolean, Error];
function useCampaigns(
  archivedStatus: IArchivedStatus,
  refetchFresh = false
): IUseCampaignsResult {
  const dispatch = useAppDispatch();

  const [loadingState, error] = useSelector(
    getCampaignsLoadingState[archivedStatus]
  );
  const loadingStateRef = React.useRef(loadingState);
  loadingStateRef.current = loadingState;
  const campaignsList = useSelector(getCampaignsList[archivedStatus]);

  React.useEffect(() => {
    if (loadingState === LoadingState.initial) {
      dispatch(fetchCampaignsWithApps[archivedStatus]());
    }
  }, [loadingState, dispatch, archivedStatus]);

  //Do not combine effect on refetchFresh with effect on loadingState
  //to avoid endless loop of re-fetching
  React.useEffect(() => {
    if (refetchFresh && loadingStateRef.current !== LoadingState.loading) {
      dispatch(fetchCampaignsWithApps[archivedStatus]());
    }
  }, [refetchFresh, dispatch, archivedStatus]);

  return [campaignsList, loadingState === LoadingState.loading, error];
}

const useActiveCampaigns = () => useCampaigns("active");
const useArchivedCampaigns = () => useCampaigns("archived");
const useFreshActiveCampaigns = () => useCampaigns("active", true);
const useFreshArchivedCampaigns = () => useCampaigns("archived", true);

export {
  useActiveCampaigns,
  useArchivedCampaigns,
  useCampaigns,
  useFreshActiveCampaigns,
  useFreshArchivedCampaigns,
};
